(function ($) {
    "use strict";


    // Closure vars
    // ------------

    var pluginName     = 'popelGmaps';
    var pluginDefaults = {
        center: '50.4254175:30.5338529',
        clickableIcons: true,
        draggable: true,
        gestureHandling: 'cooperative', // cooperative, greedy, none, auto
        noClear: true,
        zoom: 17
    };

    // A simple Object.create polyfill
    var _objectCreate = Object.create || function (obj) {
        var Empty = function () { };

        Empty.prototype = obj;

        return new Empty();
    };

    var _parseOptions = function (options) {
        var result  = $.extend(_objectCreate(pluginDefaults), options);
        var ghTypes = ['cooperative', 'greedy', 'none', 'auto'];

        result.center         = _parseCoords(result.center);
        result.clickableIcons = _parseBoolean(result.clickableIcons);
        result.draggable      = _parseBoolean(result.draggable);

        if (result.gestureHandling && ghTypes.indexOf(result.gestureHandling) === -1) {
            result.gestureHandling = 'auto';
        }

        result.noClear = _parseBoolean(result.noClear);
        result.zoom    = Number(result.zoom);

        return result;
    };

    var _parseBoolean = function (value) {
        return !!value && ['no', 'false', '0'].indexOf(value) === -1;
    };

    var _parseCoords = function (value) {
        if (typeof value === 'string' && !/^@/.test(value)) {
            var latlng = value.split(':');

            return {
                lat: Number(latlng[0]),
                lng: Number(latlng[1])
            };
        }

        return value;
    };


    // API Callback and promise
    // ------------------------
    var gmapsReady = $.Deferred();
    var noConflict;

    if (window.GoogleMapsAPICallback && typeof window.GoogleMapsAPICallback === 'function') noConflict = window.GoogleMapsAPICallback;

    window.GoogleMapsAPICallback = function () {
        gmapsReady.resolveWith(google.maps, [google.maps]);
        noConflict && noConflict();
    };

    $.googleMapsAPIReady = gmapsReady.promise();


    // Gmaps class
    // -----------

    var Gmaps = function (element, options) {
        this.$element = $(element).attr('data-toggle', 'popel-gmaps');
        this.options  = _parseOptions(options);
        this.objects  = {};
        this.markers  = [];

        // Init map
        gmapsReady.then($.proxy(function (api) {
            // Create map
            this.map = new api.Map(this.$element[0], {
                center:          this.options.center,
                clickableIcons:  this.options.clickableIcons,
                draggable:       this.options.draggable,
                gestureHandling: this.options.gestureHandling,
                noClear:         this.options.noClear,
                zoom:            this.options.zoom
            });

            // Create center LatLng object
            this.addLatLng({
                position: this.options.center
            }, 'center');

            // Add map event listeners
            this.map.addListener('bounds_changed', $.proxy(function () {
                this.$element.trigger('boundsChange.popel.gmaps');
            }, this));

            this.map.addListener('center_changed', $.proxy(function () {
                this.$element.trigger('centerChange.popel.gmaps');
            }, this));

            this.map.addListener('idle', $.proxy(function () {
                this.$element.trigger('idle.popel.gmaps');
            }, this));

            this.map.addListener('maptypeid_changed', $.proxy(function () {
                this.$element.trigger('mapTypeChange.popel.gmaps');
            }, this));

            this.map.addListener('tilesloaded', $.proxy(function () {
                this.$element.trigger('tileLoad.popel.gmaps');
            }, this));

            this.map.addListener('zoom_changed', $.proxy(function () {
                this.$element.trigger('zoomChange.popel.gmaps');
            }, this));
        }, this));
    };


    // Private methods
    // ---------------

    var _p_removeObject = function (object) {
        $.each(this.objects, $.proxy(function (k, obj) {
            if (object === obj) delete this.objects[k];
        }, this));

        $.each(this.markers, $.proxy(function (k, obj) {
            if (object === obj) this.markers.splice(k, 1);
        }, this));
    };

    var _p_getCoords = function (objectName) {
        if (!this.objects[objectName]) return false;
        var obj = this.objects[objectName];
        if (obj && obj.getPosition) return obj.getPosition();
        if (obj && obj.lat && obj.toJSON) return obj.toJSON();
        return false;
    };


    // Class methods
    // -------------

    Gmaps.prototype.resize = function () {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);

            var center = this.map.getCenter();

            api.event.trigger(this.map, 'resize');

            this.map.setCenter(center);

            return deferred.resolveWith(this);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.setCenter = function (latLng) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map || !latLng.lat || !latLng.lng) return deferred.rejectWith(this);

            this.map.panTo(latLng);

            return deferred.resolveWith(this);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.getCenter = function () {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);

            return deferred.resolveWith(this, [this.map.getCenter().toJSON()]);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.setViewport = function (sw, ne) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);

            var bounds;

            if (sw.lat && ne && ne.lat) bounds = new api.LatLngBounds(sw, ne);
            else if (sw.east && sw.north && sw.south && sw.west) bounds = sw;

            if (!bounds) return deferred.rejectWith(this);

            this.map.panToBounds(bounds);

            return deferred.resolveWith(this);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.getViewport = function () {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);

            return deferred.resolveWith(this, [this.map.getBounds().toJSON()]);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.addLatLng = function (options, name) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (name && this.objects[name]) return deferred.rejectWith(this);

            if (!options.position) options.position = this.options.center;

            var obj = new api.LatLng(options.position);

            if (name) this.objects[name] = obj;

            return deferred.resolveWith(this, [obj]);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.removeLatLng = function (latLng) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (typeof latLng === 'string') latLng = this.objects[latLng];

            if (!latLng) return deferred.rejectWith(this);

            _p_removeObject.call(this, latLng);

            return deferred.resolveWith(this);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.addMarker = function (options, name) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);
            if (name && this.objects[name]) return deferred.rejectWith(this);

            if (/^@/.test(options.position)) {
                var pname = options.position.substr(1);
                options.position = _p_getCoords.call(this, pname);
            }

            if (!options.position) options.position = this.options.center;

            var obj = new api.Marker({
                clickable:   options.clickable,
                crossOnDrag: options.crossOnDrag,
                draggable:   options.draggable,
                icon:        options.icon,
                label:       options.label,
                map:         this.map,
                position:    options.position,
                title:       options.title
            });

            if (name) this.objects[name] = obj;
            this.markers.push(obj);

            return deferred.resolveWith(this, [obj]);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.removeMarker = function (marker) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (typeof marker === 'string') marker = this.objects[marker];

            if (!marker) return deferred.rejectWith(this);

            _p_removeObject.call(this, marker);
            marker.setMap && marker.setMap(null);
            api.event.trigger(marker, 'removed');

            return deferred.resolveWith(this);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.addInfoWindow = function (options, name) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);
            if (name && this.objects[name]) return deferred.rejectWith(this);

            if (/^@/.test(options.position)) {
                var pname = options.position.substr(1);
                options.position = _p_getCoords.call(this, pname);
            }

            if (!options.position) options.position = this.options.center;

            var obj = new api.InfoWindow({
                content:        options.content,
                disableAutoPan: options.disableAutoPan,
                position:       options.position
            });

            if (name) this.objects[name] = obj;

            if (options.marker && this.objects[options.marker]) {
                var marker = this.objects[options.marker];

                if (!(marker instanceof api.Marker)) return deferred.rejectWith(this);

                marker.addListener('click', function () {
                    obj.open(this.map, marker);
                });
            }

            return deferred.resolveWith(this, [obj]);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.removeInfoWindow = function (infoWindow) {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (typeof infoWindow === 'string') infoWindow = this.objects[infoWindow];

            if (!infoWindow) return deferred.rejectWith(this);

            _p_removeObject.call(this, infoWindow);
            infoWindow.close && infoWindow.close();
            api.event.trigger(infoWindow, 'removed');

            return deferred.resolveWith(this);
        }, this));

        return deferred.promise();
    };

    Gmaps.prototype.clear = function () {
        var deferred = $.Deferred();

        gmapsReady.then($.proxy(function (api) {
            if (!this.map) return deferred.rejectWith(this);

            var promises = [];

            $.each(this.objects, $.proxy(function (i, object) {
                if (object instanceof api.LatLng) promises.push(this.removeLatLng(object));
                if (object instanceof api.Marker) promises.push(this.removeMarker(object));
                if (object instanceof api.InfoWindow) promises.push(this.removeInfoWindow(object));
            }, this));

            $.each(this.markers, $.proxy(function (i, object) {
                promises.push(this.removeMarker(object));
            }, this));

            return $.when(promises).always($.proxy(function () {
                this.$element.trigger('cleared.popel.gmaps');

                return deferred.resolveWith(this);
            }, this));
        }, this));

        return deferred.promise();
    };


    // Plugin definition
    // -----------------

    var Plugin = function (option) {
        return this.each(function () {
            var $this   = $(this),
                data    = $this.data('popel.gmaps'),
                options = typeof option == 'object' && option;

            if (!data) {
                $this.data('popel.gmaps', (data = new Gmaps(this, options)));
            }

            if (typeof option == 'string') {
                data[option]();
            }
        });
    };

    $.fn[pluginName]             = Plugin;
    $.fn[pluginName].Constructor = Gmaps;
    $.fn[pluginName].defaults    = pluginDefaults;


    // Static API
    // ----------

    var geocoder;

    $.fn[pluginName].geocode = function (address) {
        var geocodeRequest = $.Deferred();

        gmapsReady.then(function (api) {
            if (!geocoder) geocoder = new api.Geocoder();

            geocoder.geocode({
                'address': address
            }, function (results, status) {
                // Error handling
                var msg;

                if (status == 'OVER_QUERY_LIMIT') msg = 'Google Maps JavaScript API query limit reached';
                if (status == 'REQUEST_DENIED') msg = 'Geocode request denied';
                if (status == 'INVALID_REQUEST') msg = 'Invalid geocode request';
                if (status == 'UNKNOWN_ERROR') msg = 'Geocode service error';
                if (status == 'ERROR') msg = 'Geocode error';

                if (msg) {
                    console.log(msg);
                    return geocodeRequest.reject([msg]);
                }

                // Empty result set
                if (status == 'ZERO_RESULTS') return geocodeRequest.resolve([]);

                var geocodeArray = [];

                $.each(results, function (i, result) {
                    var geocodeResult = {
                        position: result.geometry.location.toJSON(),
                        precision: 'unknown',
                        viewport: result.geometry.viewport.toJSON(),
                        address: result.formatted_address,
                        addressComponents: result.address_components,
                        partial: !!result.partial_match
                    };

                    switch (result.geometry.location_type) {
                        case 'ROOFTOP': {
                            geocodeResult.precision = 'precise';
                        } break;

                        case 'RANGE_INTERPOLATED': {
                            geocodeResult.precision = 'interpolated';
                        } break;

                        case 'GEOMETRIC_CENTER': {
                            geocodeResult.precision = 'center';
                        } break;

                        case 'APPROXIMATE': {
                            geocodeResult.precision = 'approximate';
                        } break;
                    }

                    geocodeArray.push(geocodeResult);
                });

                return geocodeRequest.resolve(geocodeArray);
            });
        });

        return geocodeRequest.promise();
    };


    // Data-API
    // --------

    $('[data-toggle="popel-gmaps"]').each(function () {
        var $this   = $(this),
            options = $this.data(),
            objects = [];


        // Init the map
        $this[pluginName](options);

        var gmap = $this.data('popel.gmaps');

        // Find all objects to add to the map
        $this.find('> *').each(function () {
            var $this  = $(this),
                object = $this.data();

            if (!object.type) return;
            if (object.type == 'InfoWindow') object.content = $this.html();

            var opts = {};
            var name = object.name;

            if (object.type == 'LatLng') {
                if (object.position) opts.position = _parseCoords(object.position);

                return gmap.addLatLng(opts, name);

                $this.remove();
            }

            if (object.type == 'Marker') {
                opts.clickable   = _parseBoolean(object.clickable);
                opts.crossOnDrag = _parseBoolean(object.crossOnDrag);
                opts.draggable   = _parseBoolean(object.draggable);

                if (object.icon)     opts.icon     = object.icon;
                if (object.label)    opts.label    = object.label;
                if (object.position) opts.position = _parseCoords(object.position);
                if (object.title)    opts.title    = object.title;

                return gmap.addMarker(opts, name).then(function (marker) {
                    $this.data('marker.popel.gmaps', marker);

                    marker.addListener('click', function () {
                        $this.trigger('click.popel.gmaps');
                    });

                    marker.addListener('position_changed', function () {
                        var event = $.Event('positionChange.popel.gmaps', {
                            latLng: marker.getPosition().toJSON()
                        });
                        $this.trigger(event);
                    });

                    marker.addListener('removed', function () {
                        $this.trigger('removed.popel.gmaps');
                        $this.remove();
                    });
                });
            }

            if (object.type == 'InfoWindow') {
                opts.content = object.content;

                opts.disableAutoPan = _parseBoolean(object.disableAutoPan);

                if (object.position) opts.position = _parseCoords(object.position);
                if (object.marker)   opts.marker   = object.marker;

                return gmap.addInfoWindow(opts, name).then(function (infoWindow) {
                    $this.data('infoWindow.popel.gmaps', infoWindow);

                    infoWindow.addListener('removed', function () {
                        $this.trigger('removed.popel.gmaps');
                        $this.remove();
                    });
                });
            }
        });
    });

    $(window).on('resize.popel.gmaps', function () {
        $('[data-toggle="popel-gmaps"]')[pluginName]('resize');
    });

})(window.jQuery);
